<script lang="ts" setup>
import { computed } from 'vue'

type Props = {
  initials?: string
  color?: 'red' | 'white'
  class?: string | object
}

const props = withDefaults(defineProps<Props>(), {
  initials: undefined,
  color: 'red',
  class: undefined,
})

const classes = computed(() => {
  return {
    'app-avatar': true,
    [`app-avatar--${props.color}`]: true,
    [`${props.class}`]: !!props.class,
  }
})
</script>

<template>
  <span :class="classes">
    <template v-if="initials">{{ initials }}</template>
    <IconUser v-else />
  </span>
</template>

<style lang="scss">
@import '@boats/ui/styles/config';

.app-avatar {
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.5rem;
  height: 2.5rem;
  font-family: $font-barlow;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.03125em;
  text-transform: uppercase;
  color: $white;
  background-color: $red;
  border-radius: 50%;

  svg {
    width: 1rem;
    height: 1rem;
  }
}

.app-avatar--white {
  color: $red;
  background-color: $white;
}
</style>
